import React from "react";
import ThisTable from "../../Common/ThisTable";
import moment from "moment";
import "./ViewOutOfUse.css";
import { blueCardMethods } from "../../BlueCardReport/BlueCardReportView/HelperMethods";
import { versionInfo } from "../../MainPage/VersionInfo";
import { MyButton } from "../../Common/Forms/formsMiscItems";
import OutOfUseEntriesContainer from "../../AssetView/BlueCard/InitaializeBlueCard/OutOfUseEnteries";

const CardNumberStyle = {
  fontWeight: "550",
  marginRight: "20px",
  fontSize: "20px",
  paddingBlock: "5px",
};

const ViewOutOfUse = (props) => {
  const { OutOfUse, selectedAsset, credit } = props;

  const updateOPt2 = (opt2) => {
    return opt2.map((x) => {
      x.daysDiff = blueCardMethods.calculateOOUDays(x.start, x.end);
      return x;
    });
  };

  return (
    <div className="VOU_Container">
      <h3 className="VOU_Header">OUT OF USE HISTORY</h3>
      <div className="D-Container-container1">
        <div className="infoContainerDash">
          <div>Name</div>
          <div style={CardNumberStyle}>{selectedAsset && selectedAsset.unitId}</div>
        </div>

        <div className="infoContainerDash">
          <div>Available Out of Use Credit</div>
          <div style={CardNumberStyle}>{credit}</div>
        </div>
      </div>
      {!versionInfo.isManualOOUEnabled() && (
        <ThisTable
          tableColumns={columns}
          tableData={OutOfUse ? updateOPt2(OutOfUse.opt2) : []}
          pagination={true}
          pageSize={10}
          showPaginationBottom={true}
          classNameCustom="my-custom-class"
        />
      )}

      {props.assetId && versionInfo.isManualOOUEnabled() && (
        <div>
          <OutOfUseEntriesContainer
            assetId={props.assetId}
            userList={props.userList}
            disableCertifiedCheck={true}
            disallowHistoricalEntries={true}
            allowOpenEntryEdit={true}
            assetDbOOU={props.assetDbOOU}
            updateOOuEntries={props.updateOOuEntries}
            renderActions={props.renderActions}
            hideNotes={true}
            disableEditableTableStyle={true}
            showInBlueCardFunctionality={true}
            enableEditedByUserColumn={true}
            OOUOnLoadState={props.OOUOnLoadState}
          />
          <MyButton onClick={props.handleOOULookupSave} disabled={props.saveDisabled} style={{ marginTop: "10px" }}>
            Save
          </MyButton>
        </div>
      )}
      <div>
        <span style={{ fontSize: "16px", fontWeight: "bold" }}>Note:</span>{" "}
        <span style={{ fontSize: "14px" }}>Credits can only be applied if all available entries are reviewed and certified.</span>
      </div>
    </div>
  );
};

export default ViewOutOfUse;

const columns = [
  {
    Header: "Status",
    accessor: "status",
    Cell: ({ value }) => {
      if (!value) {
        return "OPEN";
      }
      return value;
    },
  },

  {
    Header: "Start Date",
    accessor: "start",
    Cell: ({ value }) => {
      if (!value) {
        return "";
      }
      return moment(value).format("MM/DD/YYYY");
    },
  },
  {
    Header: "End Date",
    accessor: "end",
    Cell: ({ value }) => {
      if (!value) {
        return "";
      }
      return moment(value).format("MM/DD/YYYY");
    },
  },
  {
    Header: "Credit Applied Date",
    accessor: "appliedDate",
    Cell: ({ value }) => {
      if (!value) {
        return "";
      }
      return moment(value).format("MM/DD/YYYY");
    },
  },
  {
    Header: "Total no of Days",
    accessor: "daysDiff",
  },
];



// WEBPACK FOOTER //
// ./src/components/ReVAMPOutOfUse/viewOutOfUse/ViewOutOfUse.jsx